import React from 'react';
import './App.css';
import MapView from "./features/map/MapView";
import { ToastContainer } from "./features/ui/ToastContainer";
import 'font-awesome/css/font-awesome.min.css';

function App() {
    return (
        <div className="App">
            <ToastContainer />
            <MapView />
        </div>
    );
}

export default App;
